import { render, staticRenderFns } from "./SessionObjectCardSingleAnswer.vue?vue&type=template&id=96446e7e&"
import script from "./SessionObjectCardSingleAnswer.vue?vue&type=script&lang=js&"
export * from "./SessionObjectCardSingleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports